var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedianCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1460_37019",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1460_37019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5577 20.7077C13.3656 20.8987 13.1274 20.9942 12.8434 20.9942C12.5593 20.9942 12.3218 20.8987 12.1308 20.7077L3.33078 11.9077C3.22436 11.8013 3.14262 11.6845 3.08557 11.5572C3.02852 11.43 3 11.2942 3 11.15V4C3 3.73205 3.09967 3.49839 3.29902 3.29902C3.49839 3.09967 3.73205 3 4 3H11.15C11.2795 3 11.4083 3.02638 11.5363 3.07915C11.6644 3.13193 11.7753 3.20298 11.8692 3.2923L20.6692 12.0981C20.8731 12.3019 20.9782 12.5484 20.9846 12.8375C20.991 13.1266 20.8987 13.3667 20.7077 13.5577L13.5577 20.7077ZM12.8356 20L19.9942 12.85L11.1586 4H4V11.15L12.8356 20ZM6.49775 7.5C6.7749 7.5 7.01123 7.403 7.20673 7.209C7.40224 7.01498 7.5 6.77941 7.5 6.50228C7.5 6.22511 7.403 5.98878 7.209 5.79328C7.015 5.59776 6.77942 5.5 6.50225 5.5C6.2251 5.5 5.98878 5.597 5.79328 5.791C5.59776 5.98502 5.5 6.22059 5.5 6.49773C5.5 6.77489 5.597 7.01122 5.791 7.20672C5.985 7.40224 6.22058 7.5 6.49775 7.5Z",
    fill: "#4B4566"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedianCost);
export default __webpack_public_path__ + "static/media/median_cost.0499e00c3af4d4d07da4c17f2be8ed5b.svg";
export { ForwardRef as ReactComponent };